import _, { get } from "lodash";
import { updateIgnition } from "../lib/axle";
import { InlineError } from "../components/Field";
import StepBody from "../components/StepBody";
import StepHeading from "../components/StepHeading";
// External dependencies
import { useEffect, useState } from "react";

const UnsupportedCarrier = ({
  step,
  session,
  client,
  loginInformation,
  posthog,
  nextStep,
}) => {
  // const local = false;
  const [error, setError] = useState(null);

  useEffect(() => {
    posthog.capture("$pageview", { step });
    const exit = async () => {
      // If Ignition session has a redirectUri, redirect user with status = failed as query param
      // else, send ignition.failed webhook

      const lastEvent = {
        type: `ignition.completed`,
        data: {
          token: session.id,
          // config: session.config,
          result: loginInformation.result,
          user: session.user,
        },
        createdAt: new Date().toISOString(),
      };

      // Update Ignition session
      const params = {
        status: "completed",
        lastEvent,
      };
      const [updateIgnitionResponse, updateIgnitionError] =
        await updateIgnition(session.id, params);

      if (updateIgnitionError) {
        switch (get(updateIgnitionError, "code")) {
          case 500:
            console.log(JSON.stringify(updateIgnitionError));
            nextStep("axle-error");
            return;
          default:
            nextStep("connection-error");
            return;
        }
      }

      session.redirectUri &&
        (window.location.href = `${session.redirectUri}?status=complete&result=${loginInformation.result}`);
    };
    exit();
  }, []);

  return (
    <StepBody className="items-center text-center">
      {error && (
        <div
          className="self-stretch rounded border border-danger-border p-3 text-left"
          role="status"
        >
          <InlineError>{error}</InlineError>
        </div>
      )}
      <div
        aria-hidden
        style={{ backgroundImage: `url("./icons/success.svg")` }}
        className="h-32 w-full flex-none bg-contain bg-center bg-no-repeat"
      ></div>
      <StepHeading
        align="center"
        title="All set!"
        description={
          <>
            Your verified insurance coverage will be shared with{" "}
            {client.displayName}.
          </>
        }
      />
    </StepBody>
  );
};

export default UnsupportedCarrier;
